<template>
  <section class="content">
    <div class="box box-info">
      <div class="p-toolbar p-component mb-4">
        <measurementUnitdialog ref="unitdialog"/>
        </div>
        <measurementUnitList @delete-message="deleteMessage" @edit-account="editMeasurementUnit"/>
      </div>
  </section>
</template>
<script>
import measurementUnitList from './measurementUnitList.vue'
import measurementUnitdialog from '../itemDialog/measurementUnitDialog'
export default {
  name: 'accountgroup',
  data() {
    return {
    }
  },
  methods: {
    editMeasurementUnit(data) {
      this.$refs.unitdialog.editMeasurementUnit(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    measurementUnitList,
    measurementUnitdialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// MeasurementUnit.vue?50088467